import React, { createContext, useContext, useMemo } from 'react';
import { useRaceEngine } from './useRaceEngine';

const RaceEngineContext = createContext(null);

export const RaceEngineProvider = ({ children }) => {
  // useRaceEngine ya gestiona selectedCharacter, setSelectedCharacter,
  // selectedAptitudes, setSelectedAptitudes — incluyendo el auto-trigger.
  // El Context es un bridge puro. No duplicar estado aquí.
  const engineState = useRaceEngine();

  const value = useMemo(() => ({
    ...engineState,
  }), [engineState]);

  return (
    <RaceEngineContext.Provider value={value}>
      {children}
    </RaceEngineContext.Provider>
  );
};

export const useRaceEngineContext = () => {
  const context = useContext(RaceEngineContext);
  if (!context) {
    throw new Error('useRaceEngineContext debe utilizarse obligatoriamente dentro de un RaceEngineProvider');
  }
  return context;
};
